'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var safelyCall = function safelyCall(method) {
  return function () {
    var returnValue = void 0;

    try {
      var _window$Raven;

      returnValue = (_window$Raven = window.Raven)[method].apply(_window$Raven, arguments);
    } catch (error) {
      setTimeout(function () {
        throw error;
      }, 0);
    }

    return returnValue;
  };
};

var captureException = exports.captureException = safelyCall('captureException');
var setExtraContext = exports.setExtraContext = safelyCall('setExtraContext');


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-infrastructure/static-1.19/js/sentry/RavenWrapper.js
// module id = 402
// module chunks = 2 3